import { render, staticRenderFns } from "./relatedOrganizations.vue?vue&type=template&id=34352661"
import script from "./relatedOrganizations.vue?vue&type=script&lang=js"
export * from "./relatedOrganizations.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports